var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_2809)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2785 9.23117L13.694 7.64659C13.4872 7.45233 13.2162 7.34087 12.9325 7.33341C12.6489 7.32594 12.3724 7.423 12.1557 7.60611L6.95086 12.8109C6.76393 12.9994 6.64754 13.2465 6.62122 13.5107L6.37255 15.9222C6.36476 16.0069 6.37575 16.0923 6.40474 16.1723C6.43373 16.2523 6.48 16.3248 6.54026 16.3849C6.5943 16.4385 6.65838 16.4809 6.72884 16.5097C6.7993 16.5384 6.87475 16.553 6.95086 16.5526H7.00291L9.41447 16.3328C9.67864 16.3065 9.92571 16.1901 10.1142 16.0032L15.319 10.7984C15.521 10.585 15.6302 10.3002 15.6226 10.0064C15.615 9.71265 15.4913 9.43387 15.2785 9.23117ZM13.3123 11.1627L11.7624 9.61285L12.8901 8.45623L14.4689 10.035L13.3123 11.1627Z",
    fill: "#990000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_2809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPro);
export default __webpack_public_path__ + "static/media/EditPro.28b45d64720e166e47e709cc2e628112.svg";
export { ForwardRef as ReactComponent };